import { Component } from '@angular/core';
import {LoginDialogComponent} from "../login-dialog/login-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {NeuralDissolveDirective} from "../../directives/particles.directive";

@Component({
  selector: 'app-hero-section',
  standalone: true,
  imports: [CommonModule, RouterModule, NeuralDissolveDirective],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.css'
})
export class HeroSectionComponent {

  constructor(public dialog: MatDialog) {
  }
  openLoginDialog(event: Event): void {
    event.preventDefault(); // Empêche la navigation par défaut
    this.dialog.open(LoginDialogComponent, {
      disableClose: true,  // Empêche la fermeture par clic en dehors
      panelClass: 'custom-dialog-container',  // Optionnel si tu veux utiliser un style Angular
    });
  }

}
